import { render, staticRenderFns } from "./DormitoryParkingList.vue?vue&type=template&id=112c7fda&scoped=true&"
import script from "./DormitoryParkingList.vue?vue&type=script&lang=js&"
export * from "./DormitoryParkingList.vue?vue&type=script&lang=js&"
import style0 from "./DormitoryParkingList.vue?vue&type=style&index=0&id=112c7fda&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "112c7fda",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCardTitle,VCol,VContainer,VForm,VRow})
